import styled from 'styled-components';

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  background-image: url("../../../assets/backgroundmap.svg");
  background-repeat: no-repeat;
  background-position: center;

`

export const Content = styled.div`
  padding-right: 35rem;

  h1 {
    font-size: 4rem;
    font-weight: medium;
  }
  h4 {
    color: var(--primary);
    font-size: 1.5rem;
    margin-bottom: 3rem;
  }
  p {
    margin-top: 1.5rem;
    color: var(--grey-100);
    margin-bottom: 2.75rem;
    font-size: 1rem;
  }

  @media (min-width: 1280px) {
    margin-right: 0;

    img {
      margin-bottom: 3rem;
    }

    h1 {
      font-size: 2.4rem;
      line-height: normal;
    }

    p {
      font-size: 0.95rem;
    }
  }
`